import { ELEMENT_LIC, ELEMENT_PARAGRAPH } from '@udecode/plate';

const BLOCK_TYPES = [ELEMENT_PARAGRAPH, ELEMENT_LIC];
export default BLOCK_TYPES;
